<div
  class="mg-sidebar"
  [ngClass]="{
    'mg-sidebar-desktop-active': statusMenu,
    'mg-sidebar-desktop': !statusMenu
  }"
>
  <menu class="mg-sidebar__menu">
    <div class="mg-sidebar__menu__top-icon">
      <div class="mg-sidebar__menu__top-icon__content">
        <img
          src="https://cdn.mango-soft.com/mango-core/mango-vertical.svg"
          class="squared_logo"
          *ngIf="!statusMenu"
        />
        <img
          src="https://cdn.mango-soft.com/mango-core/mango-horizontal.svg"
          *ngIf="statusMenu"
          class="squared_logo_horizontal"
        />
      </div>
    </div>

    <div class="mg-sidebar__menu__modules">
      <div class="mg-sidebar__menu__modules__app">
        <div
          class="mg-sidebar__menu__modules__app__item"
          [ngClass]="{
            'mg-sidebar__menu__modules__app__item-disable': !item.status
          }"
          [title]="item.title"
          *ngFor="let item of modules"
        >
          <div
            class="item-list"
            [routerLink]="item.status ? item.route : null"
            (click)="selectedModule()"
            [queryParams]="item.queryParams"
            *ngIf="!item?.children || item?.children?.length === 0"
            routerLinkActive="mg-sidebar__menu__modules__app__item-active"
          >
            <mat-icon class="mg-sidebar__menu__modules__app__item__icon">{{
              item.icon
            }}</mat-icon>
            <p
              *ngIf="statusMenu"
              class="mg-sidebar__menu__modules__app__item__text"
            >
              {{ item.title }}
            </p>
          </div>

          <div
            class="item-list-expanded"
            [ngClass]="{
              'mg-sidebar__menu__modules__app__item-active-principal':
                isRootUrl(item)
            }"
            *ngIf="item.children && item.children.length > 0"
          >
            <div
              class="item-list-expanded-principal"
              routerLinkActive="mg-sidebar__menu__modules__app__item-active-principal"
              (click)="toggleSubmenu(item, $event)"
            >
              <div class="item-list-expanded-principal-container">
                <mat-icon class="mg-sidebar__menu__modules__app__item__icon">{{
                  item.icon
                }}</mat-icon>
                <p
                  *ngIf="statusMenu"
                  class="mg-sidebar__menu__modules__app__item__text"
                >
                  {{ item.title }}
                </p>
              </div>
              <mat-icon
                *ngIf="item.children && item.children.length > 0"
                class="mg-sidebar__menu__modules__app__item__icon-arrow"
              >
                {{ item.expanded ? "expand_more" : "chevron_right" }}
              </mat-icon>
            </div>
            <ng-container *ngIf="item.expanded">
              <div
                *ngFor="let children of item.children"
                [routerLink]="children.route"
                (click)="selectedModule()"
                [queryParams]="children.queryParams"
                class="item-list sub-menu"
                routerLinkActive="mg-sidebar__menu__modules__app__item-active"
                [ngClass]="{
                  'mg-sidebar__menu__modules__app__submenu__item-disable':
                    !children.status
                }"
              >
                <mat-icon
                  class="mg-sidebar__menu__modules__app__item__icon-list"
                  >{{ children.icon }}</mat-icon
                >
                <p
                  *ngIf="statusMenu"
                  class="mg-sidebar__menu__modules__app__item__text-list"
                >
                  {{ children.title }}
                </p>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="mg-sidebar__menu__modules__line">
        <hr class="border" />
      </div>

      <ng-container *ngIf="showModules && modulesToolbar.length > 1">
        <div
          class="mg-sidebar__menu__modules__mango"
          *ngFor="let modules of modulesToolbar"
          (click)="moduleMangoSelected(modules)"
        >
          <img
            [src]="modules.logo"
            onerror="this.onerror=null;this.src='https://cdn.mango-soft.com/default-image.svg';"
            class="mg-sidebar__menu__modules__mango__icon"
            [alt]="modules.customNameModule"
          />
          <span
            *ngIf="statusMenu"
            class="mg-sidebar__menu__modules__mango__text"
            >{{ modules.customNameModule }}</span
          >
        </div>
      </ng-container>

      <div
        class="mg-sidebar__menu__modules__line"
        *ngIf="showModules && modulesToolbar.length > 0"
      >
        <hr class="border" />
      </div>
      <div
        *ngIf="installEvent"
        class="mg-sidebar__menu__modules__app__item item-install item-list"
        (click)="installApp()"
      >
        <mat-icon class="mg-sidebar__menu__modules__app__item__icon"
          >get_app</mat-icon
        >
        <p class="mg-sidebar__menu__modules__app__item__text">
          Instalar aplicación
        </p>
      </div>
      <div class="mg-sidebar__menu__modules__settings">
        <div
          class="mg-sidebar__menu__modules__settings__options"
          (click)="logout()"
        >
          <mat-icon class="mg-sidebar__menu__modules__settings__options__icon"
            >logout</mat-icon
          >
          <span class="mg-sidebar__menu__modules__settings__options__text"
            >{{ settings.length > 0 ? settings[1].name : "" }}
          </span>
        </div>
        <div
          class="mg-sidebar__menu__modules__settings__options"
          (click)="togglePopoverLanguage()"
        >
          <mat-icon
            [size]="20"
            class="mg-sidebar__menu__modules__settings__options__icon"
            >translate</mat-icon
          >
          <span class="mg-sidebar__menu__modules__settings__options__text"
            >{{ settings.length > 0 ? settings[2].name : "Language" }}
          </span>
          <div class="mg-sidebar__menu__modules__settings__options__popup">
            <mg-translate
              (closeTraslate)="closeTraslate($event)"
              *ngIf="defaultVisibleLanguage"
              [figure]="false"
            ></mg-translate>
          </div>
        </div>
      </div>
    </div>

    <div class="mg-sidebar__menu__botton-menu">
      <div
        class="mg-sidebar__menu__botton-menu__icons"
        (click)="openModalVersion()"
      >
        <div
          class="mg-sidebar__menu__botton-menu__icons__new-version"
          *ngIf="newVersion && ids && ids?.pk && ids?.sk"
        ></div>
        <img
          src="https://cdn.mango-soft.com/mango-core/mango_collapsed_powerby.png"
          alt="icon-mango"
          class="mg-sidebar__menu__botton-menu__icons__icon"
          *ngIf="!statusMenu"
        />
        <img
          src="https://cdn.mango-soft.com/mango-core/powerby.svg"
          alt="icon-mango"
          *ngIf="statusMenu"
          class="mg-sidebar__menu__botton-menu__icons__icon-full"
        />
        <span class="mg-sidebar__menu__botton-menu__icons__version"
          >V.{{ version }}</span
        >
      </div>

      <div class="mg-sidebar__menu__botton-menu__show-menu">
        <mat-icon
          [size]="24"
          (click)="changeMenu()"
          [hover]="true"
          class="mg-sidebar__menu__botton-menu__show-menu__icon"
          >arrow_circle_left</mat-icon
        >
      </div>
    </div>
  </menu>
</div>
